import React from "react";
import NewDate from "./Date";
import WeatherTemp from "./WeatherTemp";
import "./WeatherInfo.css";

export default function WeatherInfo(props) {
  return (
		<div className="WeatherInfo">
			<h2 className="margin-top">{props.data.city}</h2>
			<NewDate date={props.data.date} />
			<h3 className="text-capitalize">{props.data.description}</h3>


			<div className="row margin-top m-1">
				<div className="col-6 d-flex justify-content-end">
					<div className="float-right">
						<img src={props.data.icon} alt={props.data.description} />
					</div>
					<div className="float-right">
						<WeatherTemp  celsius={props.data.temperature} />
					</div>
				</div>

				<div className="col-6">
					<ul>
						<li><strong>Humidity:</strong> {props.data.humidity}%</li>
						<li><strong>Wind:</strong> {props.data.wind} km/h</li>
					</ul>
				</div>
			</div>
		</div>
    );
}